import {
  useCallback,
  useContext,
  useState,
  useEffect,
  useMemo,
  FC,
  lazy,
  Suspense,
} from "react";
import { useHotkeys } from "@blueprintjs/core";
import { PortalBarKeyCombo } from "./PortalBarConfig";
import {
  CommandManagerDispatchContext,
  CommandManagerStateContext,
  isPortalBarOpen,
} from "./CommandManager";

const PortalBar = lazy(
  () => import(/* webpackChunkName: "PortalBar" */ "./PortalBar"),
);

const PRELOAD_TIME = 1500;
const PRELOAD = false;

export const PortalBarHost: FC = function PortalBarHost() {
  const state = useContext(CommandManagerStateContext);
  const dispatch = useContext(CommandManagerDispatchContext);
  const [load, setLoad] = useState(false);

  const close = useCallback(() => {
    dispatch({
      type: "CLOSE_PORTAL_BAR",
    });
  }, [dispatch]);

  const hotkeys = useMemo(
    () => [
      {
        combo: PortalBarKeyCombo,
        global: true,
        preventDefault: true,
        label: "PortalBar zeigen",
        onKeyDown: () => {
          dispatch({
            type: "OPEN_PORTAL_BAR",
          });
        },
      },
    ],
    [dispatch],
  );
  useHotkeys(hotkeys);

  useEffect(() => {
    if (!PRELOAD) {
      return;
    }

    setTimeout(() => setLoad(true), PRELOAD_TIME);
  }, []);

  const isOpen = isPortalBarOpen(state);

  useEffect(() => {
    if (isOpen) {
      setLoad(true);
    }
  }, [isOpen]);

  if (!(isOpen || load)) {
    // Don't trigger loading immediately, except if user initiated
    return null;
  }

  return (
    <Suspense fallback={null}>
      <PortalBar isOpen={isOpen} onClose={close} />
    </Suspense>
  );
};
